import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useCalendarEventsFormTypeShallowStore } from '@frontend/schedule-helpers';
import { customContextFactory } from '../hooks/custom-context-factory';
import { RenderAppointmentInfoTabContent } from '../types';
import { CalendarEventsContainer } from './Calendar/EventsPanel/CalendarEvents/CalendarEventsContainer';
import { CalendarEventsEnums } from './Calendar/types';
import { ScheduleAppointmentInfoPanel } from './schedule-appointment-info-panel';

interface Props {
  renderApptInfoPanelContent: RenderAppointmentInfoTabContent;
}

// SP-TODO: This context need to be removed once we move this panel to widget lib so we can directly use contact-panel component
export type TempApptInfoPanelContext = {
  renderApptInfoPanelContent: RenderAppointmentInfoTabContent;
};

const [TempApptInfoPanelContextProvider, useTempApptInfoPanelContext] =
  customContextFactory<TempApptInfoPanelContext>();

export { useTempApptInfoPanelContext };

export const ScheduleSidePanels = ({ renderApptInfoPanelContent }: Props) => {
  const { setSelectedForm } = useCalendarEventsFormTypeShallowStore('setSelectedForm');

  SchedulerV3.useScheduleCustomEventListener('schedule:new-appointment', () => {
    setSelectedForm(CalendarEventsEnums.APPOINTMENT_EVENT);
  });

  return (
    <>
      <CalendarEventsContainer />
      <TempApptInfoPanelContextProvider value={{ renderApptInfoPanelContent }}>
        <ScheduleAppointmentInfoPanel />
      </TempApptInfoPanelContextProvider>
    </>
  );
};
